<!--
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-11-04 16:58:50
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2026-01-21 20:08:41
 * @FilePath: \xht\git\xht-web-business\src\views\CouponQr.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="qr-issue-page" :class="{ 'qr-page-grayed': isCodeInvalid }">
      <h2>扫码发放优惠券</h2>
      <!-- 二维码失效提示 -->
      <div v-if="!validating && !isValid" class="qr-error-card">
        <div class="error-icon">⚠️</div>
        <div class="error-message">{{ invalidMsg || '二维码不可用' }}</div>
      </div>
      <!-- 正常表单 -->
      <div v-else class="qr-issue-card">
        <div v-if="validating" class="validating-tip">正在校验二维码...</div>
        
        <!-- 优惠券信息 -->
        <div v-if="isValid && !validating && couponInfo.couponName" class="coupon-info-section">
          <div class="info-title">优惠券信息</div>
          <div class="info-item">
            <span class="info-label">优惠券名称：</span>
            <span class="info-value">{{ couponInfo.couponName || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">优惠券类型：</span>
            <span class="info-value">
              <span class="coupon-type-tag" :class="couponTypeClass">{{ couponTypeText }}</span>
            </span>
          </div>
          <div v-if="couponInfo.merchantName" class="info-item">
            <span class="info-label">商户名称：</span>
            <span class="info-value">{{ couponInfo.merchantName }}</span>
          </div>
          <div v-if="couponInfo.discountText" class="info-item">
            <span class="info-label">优惠面额：</span>
            <span class="info-value">{{ couponInfo.discountText }}</span>
          </div>
          <div v-if="couponInfo.validPeriodText" class="info-item">
            <span class="info-label">有效期：</span>
            <span class="info-value">{{ couponInfo.validPeriodText }}</span>
          </div>
        </div>
        
        <div class="row">
          <label>车牌号</label>
          <input 
            :value="plate" 
            @click="openPlateKeyboard" 
            type="text" 
            placeholder="请输入车牌号" 
            :disabled="!isValid || validating"
            readonly 
          />
        </div>
        <div class="row">
          <button 
            class="btn" 
            :class="{ 'btn-disabled': !isValid || validating }"
            @click="submit"
            :disabled="!isValid || validating"
          >
            确认发放
          </button>
        </div>
      </div>
    </div>
    
    <!-- 车牌输入键盘 -->
    <PlateKeyboard
      :visible="plateKeyboardVisible"
      :value="plate"
      :maxLength="8"
      @input="handlePlateKeyboardInput"
      @close="closePlateKeyboard"
    />
    
    <!-- Code无效时的遮罩层 -->
    <div v-if="isCodeInvalid" class="qr-gray-overlay">
      <div class="qr-gray-content">
        <div class="qr-gray-icon">⚠️</div>
        <div class="qr-gray-message">二维码已过期，请重新扫码</div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateCouponQr, rotateCouponQr, invalidateCouponCode, getCouponQrInfo, redeemCoupon } from '@/api/coupon'
import PlateKeyboard from '@/components/PlateKeyboard.vue'
import store from '@/store'

export default {
  name: 'CouponQr',
  components: {
    PlateKeyboard
  },
  data () {
    return {
      plate: '',
      isValid: false,
      invalidMsg: '',
      validating: true,
      plateKeyboardVisible: false,
      isStaticQrCode: true, // 是否静态二维码，默认true
      isCodeInvalid: false, // code是否无效（与redis中的code不一致）
      savedBusinessId: '', // 保存从URL获取的businessId（供submit使用）
      savedCouponId: '', // 保存从URL获取的couponId（供submit使用）
      savedVersion: '', // 保存从URL获取的version（供submit使用）
      currentVersionFromServer: '', // 从服务端获取的当前版本号（用于验证）
      couponInfo: {
        couponName: '',
        couponType: '',
        merchantName: '',
        discountText: '',
        validPeriodText: ''
      }
    }
  },
  computed: {
    payloadData () {
      try {
        const raw = this.$route.query.payload
        if (!raw) return {}
        return JSON.parse(decodeURIComponent(raw))
      } catch (e) {
        return {}
      }
    },
    // 支持新参数格式：bid（businessId）和 cid（couponId）
    // 也兼容旧格式：payload、couponId、businessId
    couponId () { 
      // 优先使用新参数 cid
      if (this.$route.query.cid) {
        return this.$route.query.cid
      }
      // 兼容旧格式
      return this.payloadData.couponId || this.$route.query.couponId || '' 
    },
    businessId () { 
      // 优先使用新参数 bid（businessId）
      if (this.$route.query.bid) {
        return this.$route.query.bid
      }
      // 兼容旧格式：payload 或 query 中的 businessId
      return this.payloadData.businessId || this.$route.query.businessId || '' 
    },
    code () {
      // 从URL参数中获取code（动态二维码参数）
      return this.$route.query.code || ''
    },
    version () { return this.payloadData.version || this.$route.query.version || '' },
    issuedAt () { return Number(this.payloadData.issuedAt || this.$route.query.issuedAt || 0) },
    couponTypeText () {
      const map = {
        PERCENT: '折扣券',
        CASH: '代金券',
        TIME: '时长券',
        FREE: '全免券'
      }
      return map[this.couponInfo.couponType] || this.couponInfo.couponType || '-'
    },
    couponTypeClass () {
      const colorMap = {
        PERCENT: 'type-percent',
        CASH: 'type-cash',
        TIME: 'type-time',
        FREE: 'type-free'
      }
      return colorMap[this.couponInfo.couponType] || ''
    }
  },
  async mounted () {
    console.log('[CouponQr] ========== mounted 开始 ==========')
    console.log('[CouponQr] 当前时间:', new Date().toISOString())
    console.log('[CouponQr] window.location:', {
      href: window.location.href,
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash
    })
    console.log('[CouponQr] this.$route:', {
      path: this.$route.path,
      fullPath: this.$route.fullPath,
      query: this.$route.query,
      params: this.$route.params
    })
    console.log('[CouponQr] URL参数:', this.$route.query)
    
    // 接收二维码中的 token（如果有），写入 localStorage 和 Vuex store 以供请求拦截器使用
    // 注意：新版本二维码已移除 token，避免因 token 过期导致二维码每天变化
    // 如果二维码中没有 token，用户需要先登录才能发放优惠券
    const token = this.payloadData.token || this.$route.query.token
    if (token) {
      try {
        localStorage.setItem('token', token)
        // 同步更新 Vuex store 中的 token，确保请求拦截器使用正确的 token
        store.commit('SET_TOKEN', token)
        console.log('[CouponQr] token已设置')
      } catch (e) {
        console.warn('[CouponQr] 设置token失败:', e)
      }
    } else {
      console.log('[CouponQr] URL中没有token参数')
    }
    
    // 第一步：获取 businessId、couponId 和 code
    let businessIdForCheck = this.businessId
    let couponIdForCheck = this.couponId
    const codeFromUrl = this.code
    
    console.log('[CouponQr] 第一步：获取参数', {
      businessId: businessIdForCheck,
      couponId: couponIdForCheck,
      code: codeFromUrl,
      hasCode: !!codeFromUrl,
      routeQuery: this.$route.query,
      routeFullPath: this.$route.fullPath,
      routePath: this.$route.path,
      hasBusinessId: !!businessIdForCheck,
      hasCouponId: !!couponIdForCheck,
      computedBusinessId: this.businessId,
      computedCouponId: this.couponId
    })
    
    // 如果 computed 属性获取不到，尝试直接从 URL 中解析（hash 路由模式下可能需要这样）
    console.log('[CouponQr] ========== 尝试从 route.query 直接获取参数 ==========')
    console.log('[CouponQr] this.$route.query.bid:', this.$route.query.bid)
    console.log('[CouponQr] this.$route.query.cid:', this.$route.query.cid)
    console.log('[CouponQr] this.$route.query.code:', this.$route.query.code)
    
    if (!businessIdForCheck && this.$route.query.bid) {
      businessIdForCheck = this.$route.query.bid
      console.log('[CouponQr] ✓ 从 route.query.bid 直接获取 businessId:', businessIdForCheck)
    } else {
      console.log('[CouponQr] ✗ 无法从 route.query.bid 获取 businessId (businessIdForCheck已存在或query.bid不存在)')
    }
    
    if (!couponIdForCheck && this.$route.query.cid) {
      couponIdForCheck = this.$route.query.cid
      console.log('[CouponQr] ✓ 从 route.query.cid 直接获取 couponId:', couponIdForCheck)
    } else {
      console.log('[CouponQr] ✗ 无法从 route.query.cid 获取 couponId (couponIdForCheck已存在或query.cid不存在)')
    }
    
    // 如果还是获取不到，尝试从 window.location.search 或 hash 中解析
    // 同时解析 version 参数
    try {
      // 在 hash 路由模式下，查询参数可能在 hash 中
      const hash = window.location.hash || ''
      const hashQuery = hash.split('?')[1] || ''
      const search = window.location.search || ''
      
      // 优先从 hash 中解析（hash 路由模式）
      let urlParams = null
      if (hashQuery) {
        urlParams = new URLSearchParams(hashQuery)
      } else if (search) {
        urlParams = new URLSearchParams(search)
      }
      
      if (urlParams) {
        if (!businessIdForCheck && urlParams.has('bid')) {
          businessIdForCheck = urlParams.get('bid')
          console.log('[CouponQr] ✓ 从 URL 参数中获取 businessId:', businessIdForCheck)
        }
        
        if (!couponIdForCheck && urlParams.has('cid')) {
          couponIdForCheck = urlParams.get('cid')
          console.log('[CouponQr] ✓ 从 URL 参数中获取 couponId:', couponIdForCheck)
        }
        
        // 从 URL 中解析 version 参数（优先从 hash 中获取）
        if (urlParams.has('version')) {
          // 将 version 保存到 data 中，供 submit 使用
          this.savedVersion = urlParams.get('version')
          console.log('[CouponQr] ✓ 从 URL 参数中获取 version:', this.savedVersion)
        }
      }
      
      // 如果从 URL 参数中获取不到 version，尝试从 route.query 中获取
      if (!this.savedVersion && this.$route.query.version) {
        this.savedVersion = this.$route.query.version
        console.log('[CouponQr] ✓ 从 route.query 中获取 version:', this.savedVersion)
      }
    } catch (e) {
      // 解析参数失败，忽略错误
      console.warn('[CouponQr] 解析 URL 参数失败:', e)
    }
    
    console.log('[CouponQr] ========== 参数获取完成 ==========')
    console.log('[CouponQr] 最终参数:', {
      businessIdForCheck,
      couponIdForCheck,
      codeFromUrl,
      hasBusinessId: !!businessIdForCheck,
      hasCouponId: !!couponIdForCheck,
      hasCode: !!codeFromUrl
    })
    
    // 保存到 data 中，供 submit 方法使用
    if (businessIdForCheck) {
      this.savedBusinessId = businessIdForCheck
    }
    if (couponIdForCheck) {
      this.savedCouponId = couponIdForCheck
    }
    
    // 第二步：先通过 businessId 和 couponId 从服务端获取商家信息和优惠券信息
    // 需要先获取商家信息来判断是否是静态二维码
    console.log('[CouponQr] ========== 第二步：获取商家和优惠券信息 ==========')
    console.log('[CouponQr] 检查条件:', {
      businessIdForCheck,
      couponIdForCheck,
      businessIdType: typeof businessIdForCheck,
      couponIdType: typeof couponIdForCheck,
      businessIdLength: businessIdForCheck ? businessIdForCheck.length : 0,
      couponIdLength: couponIdForCheck ? couponIdForCheck.length : 0,
      willCallApi: !!(businessIdForCheck && couponIdForCheck)
    })
    
    if (businessIdForCheck && couponIdForCheck) {
      console.log('[CouponQr] ✓ 条件满足，准备调用 getCouponQrInfo 接口')
      try {
        console.log('[CouponQr] ========== 开始调用 getCouponQrInfo 接口 ==========')
        console.log('[CouponQr] 请求参数:', { 
          businessId: businessIdForCheck, 
          couponId: couponIdForCheck,
          timestamp: new Date().toISOString()
        })
        
        // 调用新接口一次性获取商家和优惠券信息
        const qrInfoRes = await getCouponQrInfo(businessIdForCheck, couponIdForCheck)
        console.log('[CouponQr] getCouponQrInfo 接口返回:', qrInfoRes)
        
        const qrInfo = qrInfoRes?.data || {}
        console.log('[CouponQr] 解析后的 qrInfo:', qrInfo)
        console.log('[CouponQr] qrInfo.business:', qrInfo.business)
        console.log('[CouponQr] qrInfo.coupon:', qrInfo.coupon)
        console.log('[CouponQr] qrInfo.version:', qrInfo.version)
        
        // 如果接口返回了版本号，保存起来用于验证
        if (qrInfo.version) {
          this.currentVersionFromServer = qrInfo.version
          console.log('[CouponQr] ✓ 从 getCouponQrInfo 接口获取到当前版本号:', this.currentVersionFromServer)
        }
        
        const businessData = qrInfo.business
        const couponData = qrInfo.coupon
        
        console.log('[CouponQr] ========== 处理商家信息 ==========')
        console.log('[CouponQr] businessData 是否存在:', !!businessData)
        
        // 处理商家信息
        if (businessData) {
          console.log('[CouponQr] businessData 内容:', businessData)
          this.couponInfo.merchantName = businessData.businessName || businessData.name || ''
          this.isStaticQrCode = businessData.isStaticQrCode !== false // 默认为true，只有明确为false时才设为false
          console.log('[CouponQr] ✓ 商家信息处理完成:', { 
            businessName: this.couponInfo.merchantName, 
            isStaticQrCode: this.isStaticQrCode,
            businessDataIsStaticQrCode: businessData.isStaticQrCode
          })
        } else {
          console.warn('[CouponQr] ✗ businessData 不存在，无法处理商家信息')
        }
        
        console.log('[CouponQr] ========== 处理优惠券信息 ==========')
        console.log('[CouponQr] couponData 是否存在:', !!couponData)
        
        // 处理优惠券信息
        if (couponData) {
          console.log('[CouponQr] couponData 内容:', couponData)
          this.couponInfo.couponName = couponData.couponName || ''
          this.couponInfo.couponType = couponData.couponType || ''
          // 如果商家信息中没有商户名称，尝试从优惠券信息中获取
          if (!this.couponInfo.merchantName && couponData.merchantName) {
            this.couponInfo.merchantName = couponData.merchantName
          }
          this.couponInfo.discountText = this.computeDiscountText({
            couponType: couponData.couponType,
            couponPriceYuan: couponData.couponPriceYuan,
            couponDiscountRatePercent: couponData.couponDiscountRatePercent,
            couponFreeMinutes: couponData.couponFreeMinutes,
            discountText: couponData.discountText
          })
          // 处理有效期
          if (couponData.couponValidityDurationStart && couponData.couponValidityDurationEnd) {
            const startDate = this.formatDateForDisplay(couponData.couponValidityDurationStart)
            const endDate = this.formatDateForDisplay(couponData.couponValidityDurationEnd)
            this.couponInfo.validPeriodText = `${startDate} 至 ${endDate}`
          } else if (couponData.validityPeriod) {
            this.couponInfo.validPeriodText = couponData.validityPeriod
          }

          // 校验优惠券是否“当前生效”（严格按后端返回的具体开始/结束时间判断）
          try {
            const now = new Date()
            const startAt = couponData.couponValidityDurationStart ? new Date(couponData.couponValidityDurationStart) : null
            const endAt = couponData.couponValidityDurationEnd ? new Date(couponData.couponValidityDurationEnd) : null
            const startValid = startAt && !isNaN(startAt.getTime())
            const endValid = endAt && !isNaN(endAt.getTime())

            // 未生效：now < startAt
            if (startValid && now.getTime() < startAt.getTime()) {
              console.warn('[CouponQr] 优惠券未生效，阻止继续发放', { now, startAt, endAt })
              this.isValid = false
              this.invalidMsg = '优惠券已失效'
              this.validating = false
              setTimeout(() => {
                alert('优惠券已失效')
                this.forceClosePage()
              }, 100)
              return
            }

            // 已过期：now > endAt（这里也拦截，避免继续发放）
            if (endValid && now.getTime() > endAt.getTime()) {
              console.warn('[CouponQr] 优惠券已过期，阻止继续发放', { now, startAt, endAt })
              this.isValid = false
              this.invalidMsg = '优惠券已失效'
              this.validating = false
              setTimeout(() => {
                alert('优惠券已失效')
                this.forceClosePage()
              }, 100)
              return
            }
          } catch (e) { /* ignore */ }
          console.log('[CouponQr] ✓ 优惠券信息处理完成:', {
            couponName: this.couponInfo.couponName,
            couponType: this.couponInfo.couponType,
            discountText: this.couponInfo.discountText
          })
        } else {
          console.warn('[CouponQr] ✗ couponData 不存在，无法处理优惠券信息')
        }
        
        console.log('[CouponQr] ========== 第二步完成，当前状态 ==========')
        console.log('[CouponQr] 当前状态:', {
          merchantName: this.couponInfo.merchantName,
          isStaticQrCode: this.isStaticQrCode,
          couponName: this.couponInfo.couponName,
          couponType: this.couponInfo.couponType
        })
        
        // 第三步：根据是否有 code 和是否是静态二维码来决定是否调用 invalidateCouponCode
        console.log('[CouponQr] ========== 第三步：处理 code 验证 ==========')
        // 如果有 code，必须调用 invalidateCouponCode 验证
        // 如果没有 code 但是静态二维码，不需要调用 invalidateCouponCode，继续正常流程
        // 如果没有 code 且不是静态二维码，提示二维码已过期
        if (codeFromUrl) {
        // 有 code 参数，调用 invalidateCouponCode 验证
        console.log('[CouponQr] ========== 检测到code参数，开始处理动态二维码 ==========')
        console.log('[CouponQr] code参数值:', codeFromUrl)
        console.log('[CouponQr] businessIdForCheck:', businessIdForCheck)
        console.log('[CouponQr] couponIdForCheck:', couponIdForCheck)
        
        if (!businessIdForCheck || !couponIdForCheck) {
          console.error('[CouponQr] 错误：URL中有code参数，但businessId或couponId为空，无法调用invalid接口', {
            businessId: businessIdForCheck,
            couponId: couponIdForCheck
          })
          this.isCodeInvalid = true
          this.validating = false
          this.isValid = false
          this.invalidMsg = '二维码参数不完整，请重新扫码'
          setTimeout(() => {
            alert('二维码参数不完整，请重新扫码')
          }, 100)
          return
        }
        
        try {
          console.log('[CouponQr] 开始调用 invalidateCouponCode 接口')
          console.log('[CouponQr] 请求参数:', {
            businessId: businessIdForCheck,
            couponId: couponIdForCheck,
            code: codeFromUrl
          })
          
          const result = await invalidateCouponCode(businessIdForCheck, couponIdForCheck, codeFromUrl)
          
          console.log('[CouponQr] invalidateCouponCode 接口返回:', result)
          console.log('[CouponQr] result.data:', result?.data)
          
          const isValidCode = result?.data || false
          console.log('[CouponQr] isValidCode:', isValidCode)
          
          if (!isValidCode) {
            // code和redis中的code不一致，灰掉页面并弹窗提示
            console.warn('[CouponQr] ========== code与redis中的code不一致，页面将被灰掉 ==========')
            this.isCodeInvalid = true
            this.validating = false
            this.isValid = false
            this.invalidMsg = '二维码已过期，请重新扫码'
            // 弹窗提示用户重新扫码
            setTimeout(() => {
              alert('二维码已过期，请重新扫码')
            }, 100)
            return // 不再继续后续流程
          }
          console.log('[CouponQr] ========== code验证通过，code已失效，之前的动态二维码无法再使用 ==========')
        } catch (e) {
          console.error('[CouponQr] ========== 使code失效失败 ==========', e)
          console.error('[CouponQr] 错误详情:', {
            message: e.message,
            response: e.response,
            stack: e.stack
          })
          // 如果接口调用失败，也认为code无效，灰掉页面
          this.isCodeInvalid = true
          this.validating = false
          this.isValid = false
          this.invalidMsg = '二维码验证失败，请重新扫码'
          setTimeout(() => {
            alert('二维码验证失败，请重新扫码')
          }, 100)
          return
        }
      } else {
        // 没有 code 参数
        console.log('[CouponQr] ========== URL中没有code参数 ==========')
        console.log('[CouponQr] isStaticQrCode:', this.isStaticQrCode)
        
        // 检查：如果没有 code 且不是静态二维码，提示二维码已过期
        if (!this.isStaticQrCode) {
          console.warn('[CouponQr] ========== 动态二维码但没有code参数，二维码已过期 ==========')
          this.isCodeInvalid = true
          this.validating = false
          this.isValid = false
          this.invalidMsg = '二维码已过期，请重新扫码'
          setTimeout(() => {
            alert('二维码已过期，请重新扫码')
          }, 100)
          return // 不再继续后续流程
        } else {
          console.log('[CouponQr] ========== 静态二维码，不需要code参数，继续正常流程 ==========')
        }
      }
      } catch (e) {
        console.error('[CouponQr] ========== 获取商家或优惠券信息失败 ==========')
        console.error('[CouponQr] 错误对象:', e)
        console.error('[CouponQr] 错误类型:', e?.constructor?.name)
        console.error('[CouponQr] 错误消息:', e?.message)
        console.error('[CouponQr] 错误响应:', e?.response)
        console.error('[CouponQr] 错误响应数据:', e?.response?.data)
        console.error('[CouponQr] 错误响应状态:', e?.response?.status)
        console.error('[CouponQr] 错误堆栈:', e?.stack)
        console.error('[CouponQr] 完整错误信息:', JSON.stringify(e, Object.getOwnPropertyNames(e)))
      }
    } else {
      console.warn('[CouponQr] ========== businessId 或 couponId 为空，无法调用 getCouponQrInfo 接口 ==========')
      console.warn('[CouponQr] 参数检查结果:', {
        businessIdForCheck,
        couponIdForCheck,
        businessIdTruthy: !!businessIdForCheck,
        couponIdTruthy: !!couponIdForCheck,
        businessIdEmpty: businessIdForCheck === '' || businessIdForCheck === null || businessIdForCheck === undefined,
        couponIdEmpty: couponIdForCheck === '' || couponIdForCheck === null || couponIdForCheck === undefined
      })
      
      // 如果没有 businessId 或 couponId，尝试从 payload 或 query 中获取信息（兼容旧版本）
      // 如果没有 businessId 或 couponId，尝试从 payload 或 query 中获取信息（兼容旧版本）
      const payload = this.payloadData
      const query = this.$route.query || {}
      this.couponInfo = {
        couponName: payload.couponName || query.couponName || '',
        couponType: payload.couponType || query.couponType || '',
        merchantName: payload.merchantName || query.merchantName || '',
        discountText: this.computeDiscountText({
          couponType: payload.couponType || query.couponType,
          couponPriceYuan: payload.couponPriceYuan || query.couponPriceYuan,
          couponDiscountRatePercent: payload.couponDiscountRatePercent || query.couponDiscountRatePercent,
          couponFreeMinutes: payload.couponFreeMinutes || query.couponFreeMinutes,
          discountText: payload.discountText || query.discountText
        }),
        validPeriodText: payload.validPeriodText || query.validPeriodText || ''
      }
    }
    
    // 第四步：设置最终状态（版本校验将在 submit 时进行）
    console.log('[CouponQr] ========== 第四步：设置最终状态 ==========')
    // 页面加载时直接判定为有效（版本校验在 submit 时进行）
    this.isValid = true
    this.invalidMsg = ''
    this.validating = false
    
    console.log('[CouponQr] ========== mounted 完成 ==========')
    console.log('[CouponQr] 完成时间:', new Date().toISOString())
    console.log('[CouponQr] 最终状态:', {
      isValid: this.isValid,
      isCodeInvalid: this.isCodeInvalid,
      invalidMsg: this.invalidMsg,
      validating: this.validating,
      isStaticQrCode: this.isStaticQrCode,
      couponInfo: {
        merchantName: this.couponInfo.merchantName,
        couponName: this.couponInfo.couponName,
        couponType: this.couponInfo.couponType
      },
      businessId: businessIdForCheck || this.businessId,
      couponId: couponIdForCheck || this.couponId,
      code: codeFromUrl || this.code
    })
    console.log('[CouponQr] ========== 执行流程总结 ==========')
    console.log('[CouponQr] 1. 参数获取:', {
      businessId: businessIdForCheck || this.businessId ? '✓' : '✗',
      couponId: couponIdForCheck || this.couponId ? '✓' : '✗',
      code: codeFromUrl || this.code ? '✓' : '✗'
    })
    console.log('[CouponQr] 2. 商家信息获取:', this.couponInfo.merchantName ? '✓' : '✗')
    console.log('[CouponQr] 3. 优惠券信息获取:', this.couponInfo.couponName ? '✓' : '✗')
    console.log('[CouponQr] 4. 版本校验:', this.isValid !== undefined ? '✓' : '✗')
    console.log('[CouponQr] 5. 最终结果:', {
      isValid: this.isValid ? '✓ 有效' : '✗ 无效',
      isCodeInvalid: this.isCodeInvalid ? '✗ code无效' : '✓ code有效',
      canProceed: this.isValid && !this.isCodeInvalid ? '✓ 可以继续' : '✗ 不能继续'
    })
  },
  methods: {
    async submit () {
      if (this.validating) return alert('正在校验二维码，请稍后')
      if (!this.isValid) return alert(this.invalidMsg || '二维码不可用')
      
      // 优先使用 data 中保存的值，如果没有则使用 computed 属性或直接从 route.query 获取
      const businessId = this.savedBusinessId || this.businessId || this.$route.query.bid || this.$route.query.businessId || ''
      const couponId = this.savedCouponId || this.couponId || this.$route.query.cid || this.$route.query.couponId || ''
      
      console.log('[CouponQr] submit 参数:', { 
        businessId, 
        couponId, 
        plate: this.plate?.trim(),
        savedBusinessId: this.savedBusinessId,
        computedBusinessId: this.businessId,
        routeQueryBid: this.$route.query.bid
      })
      
      if (!businessId) {
        console.error('[CouponQr] 商户ID缺失:', {
          savedBusinessId: this.savedBusinessId,
          computedBusinessId: this.businessId,
          routeQueryBid: this.$route.query.bid,
          routeQueryBusinessId: this.$route.query.businessId,
          routeQuery: this.$route.query
        })
        return alert('商户ID缺失，无法发放')
      }
      
      if (!couponId) {
        console.error('[CouponQr] 优惠券ID缺失:', {
          savedCouponId: this.savedCouponId,
          computedCouponId: this.couponId,
          routeQueryCid: this.$route.query.cid,
          routeQueryCouponId: this.$route.query.couponId
        })
        return alert('优惠券ID缺失，无法发放')
      }
      
      // 第一步：如果有版本号，先验证版本号是否与数据库中的版本号一致
      // 版本验证必须在所有业务逻辑验证之前执行，包括：
      // - 判断车辆是否已领取过优惠券
      // - 验证车牌号是否在场
      // 等其他验证逻辑
      // 优先使用 savedVersion（从 URL 直接解析的），然后是 computed 的 version
      const versionToCheck = this.savedVersion || this.version || ''
      
      if (versionToCheck) {
        // 提交时强制拉取一次最新版本号，避免“扫码后版本号被更新”导致校验失效
        let currentVersion = ''
        let qrInfo = null
        try {
          const qrInfoRes = await getCouponQrInfo(businessId, couponId)
          qrInfo = qrInfoRes?.data || {}
          currentVersion = qrInfo.version || ''
          if (currentVersion) {
            this.currentVersionFromServer = currentVersion
            console.log('[CouponQr] ✓ 提交时获取到当前版本号:', currentVersion)
          } else {
            console.warn('[CouponQr] 提交时未获取到版本号（qrInfo.version为空）')
          }
        } catch (e) {
          console.error('[CouponQr] 提交时获取版本号失败:', e)
        }

        // 提交时也校验一次“是否当前生效”，避免用户停留页面后跨越生效时间边界
        try {
          const now = new Date()
          const startAt = qrInfo?.coupon?.couponValidityDurationStart ? new Date(qrInfo.coupon.couponValidityDurationStart) : null
          const endAt = qrInfo?.coupon?.couponValidityDurationEnd ? new Date(qrInfo.coupon.couponValidityDurationEnd) : null
          const startValid = startAt && !isNaN(startAt.getTime())
          const endValid = endAt && !isNaN(endAt.getTime())
          if (startValid && now.getTime() < startAt.getTime()) {
            alert('优惠券已失效')
            this.forceClosePage()
            return
          }
          if (endValid && now.getTime() > endAt.getTime()) {
            alert('优惠券已失效')
            this.forceClosePage()
            return
          }
        } catch (e) { /* ignore */ }
        
        if (currentVersion) {
          console.log('[CouponQr] 使用当前版本号进行验证:', {
            qrVersion: versionToCheck,
            serverVersion: currentVersion
          })
          
          if (versionToCheck !== currentVersion) {
            // 版本号不匹配，二维码已过期
            console.warn('[CouponQr] 版本号验证失败，二维码已过期')
            alert('请扫描最新二维码')
            this.forceClosePage()
            return
          } else {
            console.log('[CouponQr] ✓ 版本号验证通过')
          }
        } else {
          // 如果仍然无法获取版本号，降级使用 validateCouponQr 接口（需要token）
          // 注意：这个接口可能需要token，如果用户未登录可能会失败
          console.log('[CouponQr] 无法获取当前版本号，降级使用 validateCouponQr 接口验证')
          try {
            const resp = await validateCouponQr(businessId, couponId, versionToCheck)
            const valid = resp?.data?.valid ?? resp?.valid ?? false
            
            if (!valid) {
              // 版本验证失败，提示并关闭页面
              alert('请扫描最新二维码')
              this.forceClosePage()
              return
            }
          } catch (e) {
            // 版本校验请求失败，可能是token问题或其他错误
            // 如果是因为token问题，提示用户；否则提示重新扫码
            console.error('[CouponQr] 版本验证失败:', e)
            if (e?.response?.status === 401 || e?.response?.status === 403) {
              // token问题，但这是扫码页面，不应该要求登录
              // 如果后端接口需要token，应该将接口添加到白名单
              console.warn('[CouponQr] 版本验证接口需要token，但用户可能未登录')
            }
            alert('请扫描最新二维码')
            this.forceClosePage()
            return
          }
        }
      } else {
        // 如果二维码没有版本号，说明可能是旧版本的二维码（没有版本号机制）
        // 对于静态二维码，如果没有版本号，应该阻止使用
        if (this.isStaticQrCode) {
          console.warn('[CouponQr] 静态二维码缺少版本号，无法验证')
          alert('二维码格式不正确，请重新扫码')
          this.forceClosePage()
          return
        }
      }
      
      // 第二步：验证车牌号（在版本验证通过后）
      if (!this.plate || !this.plate.trim()) return alert('请输入车牌号')
      
      try {
        // 版本校验通过后，调用发放接口（内部会验证车牌号是否在场等逻辑）
        // 使用新的公开接口领取优惠券（不需要JWT）
        await redeemCoupon(businessId, couponId, this.plate.trim())

        // 如果商户使用非静态二维码，发放成功后使二维码失效
        // 使用 mounted 时保存的值
        const currentIsStaticQrCode = this.isStaticQrCode !== false
        if (!currentIsStaticQrCode) {
          try {
            await rotateCouponQr(businessId, couponId)
            console.log('[CouponQr] 非静态二维码已失效，版本已更新')
            // 更新本地状态，使二维码显示为失效
            this.isValid = false
            this.invalidMsg = '已失效'
          } catch (e) {
            console.warn('[CouponQr] 更新二维码版本失败:', e)
            // 即使更新版本失败，也不影响用户体验，因为后端已经记录了发放
          }
        }

        // 发放成功后提示
        alert('发放成功')
        
        // 清空车牌号
        this.plate = ''
        
        // 强制关闭页面 - 多种方式尝试
        this.forceClosePage()
      } catch (e) {
        console.error('[CouponQr] 发放优惠券失败:', e)
        // 提取错误信息
        let errorMessage = '发放失败'
        
        // 优先从 response.data 中提取错误信息（响应拦截器抛出的错误）
        if (e.response && e.response.data) {
          const errorData = e.response.data
          if (errorData.message) {
            errorMessage = errorData.message
          } else if (errorData.error) {
            errorMessage = errorData.error
          } else if (typeof errorData === 'string') {
            errorMessage = errorData
          }
        } else if (e.message) {
          // 从 error.message 中提取（响应拦截器设置的）
          errorMessage = e.message
        }

        // 清理错误信息：去掉重复的前缀
        // 去掉 "领取优惠券失败："、"发放优惠券失败："、"发放失败：" 等重复前缀
        errorMessage = errorMessage
          .replace(/^领取优惠券失败[：:]\s*/g, '')
          .replace(/^发放优惠券失败[：:]\s*/g, '')
          .replace(/^发放失败[：:]\s*/g, '')
          .replace(/领取优惠券失败[：:]\s*/g, '')
          .replace(/发放优惠券失败[：:]\s*/g, '')
          .trim()

        // 如果清理后为空，使用默认提示
        if (!errorMessage) {
          errorMessage = '发放失败，请稍后重试'
        }

        // 检查是否是余额不足的错误
        if (errorMessage.includes('余额不足') || errorMessage.includes('不足以抵扣') || errorMessage.includes('无法发放优惠券')) {
          alert('余额不足')
          // 点击确认后不关闭页面，允许继续输入其他车牌号
        } else if (errorMessage.includes('没有在场订单') || errorMessage.includes('在场订单')) {
          // 检查是否是在场订单相关的错误
          alert('该车牌没有在场订单，无法领取优惠券')
          // 点击确认后不关闭页面，允许继续输入其他车牌号
        } else if (errorMessage.includes('已领过') || errorMessage.includes('已领取') || errorMessage.includes('重复')) {
          // 检查是否是重复领取的错误
          alert('该车牌已领取过此优惠券')
          // 点击确认后不关闭页面，允许继续输入其他车牌号
        } else {
          // 直接显示清理后的错误信息，不再加"发放失败"前缀
          alert(errorMessage)
          // 点击确认后关闭页面
          this.forceClosePage()
        }
      }
    },
    // 打开车牌输入键盘
    openPlateKeyboard () {
      this.plateKeyboardVisible = true
    },
    // 关闭车牌输入键盘
    closePlateKeyboard () {
      this.plateKeyboardVisible = false
    },
    // 处理车牌键盘输入
    handlePlateKeyboardInput (value) {
      this.plate = value
    },
    // 强制关闭页面
    forceClosePage () {
      console.log('[CouponQr] 开始强制关闭页面')
      
      // 方式1: 尝试使用微信JSBridge关闭（微信浏览器环境）
      // eslint-disable-next-line no-undef
      if (typeof WeixinJSBridge !== 'undefined') {
        try {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call('closeWindow')
          console.log('[CouponQr] 使用WeixinJSBridge关闭页面')
          return
        } catch (e) {
          console.warn('[CouponQr] WeixinJSBridge关闭失败:', e)
        }
      }
      
      // 方式2: 如果是通过 window.open 打开的，直接关闭
      if (window.opener) {
        try {
          window.close()
          console.log('[CouponQr] 使用window.close()关闭页面')
          return
        } catch (e) {
          console.warn('[CouponQr] window.close()失败:', e)
        }
      }
      
      // 方式3: 尝试返回上一页
      if (window.history.length > 1) {
        try {
          this.$router.go(-1)
          console.log('[CouponQr] 使用router.go(-1)返回上一页')
          return
        } catch (e) {
          console.warn('[CouponQr] router.go(-1)失败:', e)
        }
      }
      
      // 方式4: 使用 window.history.back()
      try {
        window.history.back()
        console.log('[CouponQr] 使用window.history.back()返回上一页')
        return
      } catch (e) {
        console.warn('[CouponQr] window.history.back()失败:', e)
      }
      
      // 方式5: 尝试关闭窗口（可能无效，但尝试一下）
      try {
        window.close()
        console.log('[CouponQr] 最后尝试window.close()')
      } catch (e) {
        console.warn('[CouponQr] 所有关闭方式都失败:', e)
        // 如果所有方式都失败，显示提示信息
        alert('优惠券已发放成功，请手动关闭页面')
      }
    },
    // 计算优惠面额文本
    computeDiscountText ({ couponType, couponPriceYuan, couponDiscountRatePercent, couponFreeMinutes, discountText }) {
      if (discountText) return discountText
      if (!couponType) return ''
      if (couponType === 'CASH') {
        const amount = couponPriceYuan
        if (amount !== undefined && amount !== null) {
          return `¥${amount}`
        }
      } else if (couponType === 'PERCENT') {
        const rate = couponDiscountRatePercent
        if (rate !== undefined && rate !== null) {
          return `${rate}%`
        }
      } else if (couponType === 'TIME') {
        const minutes = couponFreeMinutes
        if (minutes !== undefined && minutes !== null) {
          return `${minutes}分钟`
        }
      } else if (couponType === 'FREE') {
        return '全免'
      }
      return ''
    },
    // 格式化日期显示
    formatDateForDisplay (dateString) {
      if (!dateString) return ''
      try {
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return dateString
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      } catch (e) {
        console.warn('日期格式化失败:', dateString, e)
        return dateString
      }
    }
  }
}
</script>

<style scoped>
.qr-issue-page { max-width: 430px; margin: 0 auto; padding: 24px; position: relative; }
.qr-issue-page.qr-page-grayed {
  filter: grayscale(100%);
  opacity: 0.5;
  pointer-events: none;
}
.qr-issue-card { background: #fff; border-radius: 12px; box-shadow: 0 6px 16px rgba(0,0,0,.06); padding: 16px; }
.qr-error-card {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 6px 16px rgba(0,0,0,.06);
}
.error-icon {
  font-size: 48px;
  margin-bottom: 12px;
}
.error-message {
  font-size: 16px;
  color: #856404;
  font-weight: 500;
  line-height: 1.5;
}
.validating-tip {
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-bottom: 16px;
  padding: 8px;
}
.row { display: flex; align-items: center; margin: 12px 0; }
label { width: 68px; color: #555; }
input { 
  flex: 1; 
  height: 36px; 
  border: 1px solid #e5e6eb; 
  border-radius: 8px; 
  padding: 0 10px; 
  cursor: pointer; 
}
input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  color: #999;
}
.btn { 
  width: 100%; 
  height: 40px; 
  background: #3572e6; 
  border: none; 
  color: #fff; 
  border-radius: 8px; 
  cursor: pointer; 
  transition: background 0.2s;
}
.btn:hover:not(.btn-disabled) {
  background: #2d5fd6;
}
.btn-disabled {
  background: #ccc;
  cursor: not-allowed;
}
.coupon-info-section {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}
.info-title {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e6eb;
}
.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  font-size: 14px;
}
.info-item:last-child {
  margin-bottom: 0;
}
.info-label {
  color: #666;
  min-width: 80px;
  flex-shrink: 0;
}
.info-value {
  color: #222;
  flex: 1;
  word-break: break-all;
}
.coupon-type-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
.coupon-type-tag.type-percent {
  background: #e6f7ff;
  color: #1890ff;
}
.coupon-type-tag.type-cash {
  background: #f6ffed;
  color: #52c41a;
}
.coupon-type-tag.type-time {
  background: #fff7e6;
  color: #fa8c16;
}
.coupon-type-tag.type-free {
  background: #f9f0ff;
  color: #722ed1;
}
/* Code无效时的遮罩层样式 */
.qr-gray-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.qr-gray-content {
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px;
  text-align: center;
  max-width: 320px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}
.qr-gray-icon {
  font-size: 64px;
  margin-bottom: 16px;
}
.qr-gray-message {
  font-size: 16px;
  color: #222;
  font-weight: 500;
  line-height: 1.5;
}
</style>


